import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'

export default class InfiniteScroll extends Component {
  static propTypes = {
    children: PropTypes.any,
    hasMore: PropTypes.func.isRequired,
    loadMore: PropTypes.func.isRequired,
    threshold: PropTypes.number,
    getContainer: PropTypes.func,
  }

  static defaultProps = {
    threshold: 250,
    getContainer: () => {},
  }

  componentDidMount() {
    const { getContainer } = this.props
    this.container = getContainer()
    this.attachEvents()
    this.scrollListener()
  }

  componentWillUnmount() {
    this.removeEvents()
  }

  attachEvents = () => {
    const container = this.container || window
    container.addEventListener('scroll', this.scrollListener)
  }

  removeEvents = () => {
    const container = this.container || window
    container.removeEventListener('scroll', this.scrollListener)
  }

  scrollListener = () => {
    const { hasMore, loadMore, threshold } = this.props

    let scrollHeight
    let innerHeight
    let scrollTop

    if (this.container) {
      ({ scrollHeight, scrollTop, clientHeight: innerHeight } = this.container)
    } else {
      ({ scrollHeight } = document.body);
      ({ innerHeight, pageYOffset: scrollTop } = window)
    }

    if (scrollHeight - scrollTop - innerHeight < threshold && hasMore()) {
      loadMore(this.scrollListener)
    }
  }

  render() {
    const { children } = this.props
    return (
      <Fragment>
        { children }
      </Fragment>
    )
  }
}
